export const TranslationsDE = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: 'Online bestellen',
        cart: 'Warenkorb',
        open_24: '24 Stunden geöffnet',
        closed: 'Geschlossen',
        free: 'KOSTENLOS',
        something_went_wrong: 'Etwas lief schief',
        try_again: 'Nochmal versuchen',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Montag',
                tuesday: 'Dienstag',
                wednesday: 'Mittwoch',
                thursday: 'Donnerstag',
                friday: 'Freitag',
                saturday: 'Samstag',
                sunday: 'Sonntag',
            },
        },
        services: {
            pickup: 'Abholung',
            delivery: 'Lieferung',
            dine_in: 'Vor-Ort Speisen',
            table_booking: 'Tisch Reservierung',
        },
        payment: {
            method: {
                cash: 'Bar',
                card: 'Karte',
                stripe: 'Kreditkarte',
                paypal: 'PayPal',
                cardconnect: 'Kreditkarte',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                custom: 'Benutzerdefiniert',
            },
            backend_method: {
                cash: 'Bar',
                card: 'Karte',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'Kreditkarte',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                custom: 'Benutzerdefiniert',
            },
            status: {
                success: 'Erfolgreich',
                pending: 'Ausstehend',
                error: 'Fehlgeschlagen',
                refunded: 'Zurückerstattet',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Entfernen',
                drop_here: 'Legen Sie Ihre Dateien hier ab oder klicken Sie um eine auszuwählen',
                accepts: 'Folgende Dateiformate werden akzeptiert {{filesTypes}}',
                errors: {
                    max_files: 'Maximal {{number}} zulässig',
                    max_size: 'Maximale Dateigröße darf {{kilobytes}} KB nicht überschreiten',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Das Geschäft ist derzeit geschlossen. Sie können versuchen, zu einem späteren Datum/Uhrzeit zu bestellen',
            },
            buttons: {
                order: {
                    book_order: 'Tischreservierung / Onlinebestellung',
                    order_online: 'Online bestellen',
                    book_table: 'Tisch reservieren',
                    order: 'Bestellen',
                    book: 'Reservieren',
                    cart: 'Warenkorb',
                    restart: 'Neu Start',
                    closed: 'Geschäft geschlossen',
                    not_accepting: 'Bestellungen werden nicht angenommen',
                },
            },
        },
        modals: {
            auth: {
                login: 'Einloggen',
                register: 'Registrieren',
                register_commence: 'Fortsetzen',
                register_complete: 'Konto erstellen',
                register_confirmation_sent: 'Ein Bestätigungscode wurde an Ihre E-Mail-Adresse gesendet. Bitte geben Sie ihn unten ein, um fortzufahren',
                register_confirmation_resent: 'Der Bestätigungscode wurde erneut gesendet. Überprüfen Sie Ihren Spamordner oder starten Sie den Vorgang erneut',
                register_restart: 'Registrierung erneut durchführen',
                register_resend_code: 'Code erneut senden',
                login_placeholder: 'Email',
                password_placeholder: 'Passwort',
                confirm_password_placeholder: 'Passwort bestätigen',
                confirmation_code_placeholder: 'E-Mail Bestätigungscode',
                accept_terms: 'Nutzungsbedingungen akzeptieren',
                accept_terms_view: 'Ansicht',
                login_facebook: 'Mit Facebook einloggen',
                login_google: 'Loggen Sie sich mit Google ein',
                benefits: 'Loggen Sie sich ein oder erstellen Sie ein Konto, um Ihre Bestellungen zu speichern',
                logged_in: 'Erfolgreich eingeloggt',
                logged_out: 'Abgemeldet',
                password_reset: {
                    init_button: 'E-Mail zum Zurücksetzen des Passworts senden',
                    init_success: 'Der Link zum Zurücksetzen des Passworts wurde an Ihre E-Mail-Adresse gesendet',
                    complete_button: 'Passwort zurücksetzen',
                    complete_success: 'Passwort erfolgreich zurückgesetzt, melden Sie sich mit Ihrem neuen Passwort an',
                    forgot_password_text: 'Passwort vergessen?',
                    forgot_password_link: 'Passwort zurücksetzen',
                    remember_password_text: 'Erinnern Sie sich an Ihr Passwort?',
                    remember_password_link: 'Zurück',
                    invalid_title: 'Passwort zurücksetzen fehlgeschlagen',
                    invalid_description: 'Dieser Link zum Zurücksetzen des Passworts ist ungültig. Fordern Sie stattdessen einen neuen an',
                    invalid_link: 'zum Login',
                    title: 'Passwort zurücksetzen',
                    description: 'Geben Sie ein neues Passwort für Ihr Konto ein',
                },
                error_generic: 'Etwas ist schief gelaufen, Bitte versuchen Sie es erneut oder kontaktieren Sie uns',
                error_accept_terms: 'Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen',
                error_password_length: 'Mindestens 6 Zeichen für das Passwort eingeben',
                error_social: 'Es ist ein Fehler aufgetreten. Versuchen Sie es erneut oder kontaktieren Sie uns',
                error_confirmation_code: 'ungültiger Bestätigungscode',
                error_invalid_code: 'ungültiger Bestätigungscode',
                error_exists: 'Benutzer ist bereits vorhanden',
                error_invalid_email_pass: 'Ungültige Emailadresse oder Passwort',
                error_password_no_match: 'Passwörter stimmen nicht überein',
                error_user_not_found: 'Kein Benutzer mit dieser E-Mail-Adresse gefunden',
                error_invalid_email: 'Ungültige E-Mail-Adresse',
                error_invalid_reset_token: 'Ungültiger Reset-Link, fordern Sie einen anderen an',
            },
            booking: {
                form: {
                    name: 'Vollständiger Name',
                    email: 'E-Mail-Addresse',
                    phone: 'Telefonnummer',
                    number_of_people: 'Anzahl der Personen',
                    number_of_people_max: 'Maximale Anzahl der Personen ({{max_people}})',
                    number_of_people_min: 'Mindest Anzahl der Personen ({{min_people}})',
                    number_of_people_max_min: 'Anzahl der Personen (Zwischen {{min_people}} und {{max_people}})',
                    number_of_guests: 'Anzahl der Gäste',
                    notes: 'Anmerkungen / Spezialwünsche',
                    submit: 'Buchungsanfrage abschicken',
                    email_optional: '(optional)',
                    date: 'Datum',
                    duration: 'Dauer',
                    seating: 'Verfügbare Zeiten',
                    notes_placeholder: 'Allergien, Anlass, Sitzplatzwunsch',
                    reserving: 'Reservierung wird gesendet...',
                    reserve_table: 'Tisch reservieren',
                    please_choose_a_date_and_time: 'Bitte wählen Sie ein Datum und eine Uhrzeit.',
                    invalid_people: 'Die Gruppengröße muss zwischen {{min}} und {{max}} liegen.',
                    party_size_max_fallback: 'dem erlaubten Maximum',
                    loading_available_times: 'Verfügbare Zeiten werden geladen…',
                    select_a_date_to_see_available_times: 'Wählen Sie ein Datum, um verfügbare Zeiten zu sehen.',
                    no_times_available_for_this_date: 'Für dieses Datum sind keine Zeiten verfügbar. Bitte wählen Sie einen anderen Tag.',
                    shift: 'Schicht',
                    service_times: 'Servicezeiten',
                    new_shift: 'Neue Schicht',
                    time: 'Zeit',
                    times: 'Zeiten',
                    unavailable: 'Nicht verfügbar',
                    available: 'Verfügbar',
                    required_name: 'Bitte geben Sie Ihren Namen ein.',
                    required_phone: 'Bitte geben Sie Ihre Telefonnummer ein.',
                    required_email: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
                    invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
                    required_terms: 'Bitte akzeptieren Sie die Bedingungen, bevor Sie reservieren.',
                    missing_custom_fields: 'Bitte beantworten Sie alle Pflichtfragen.',
                    reservation_is_unavailable: 'Reservierungen sind nicht verfügbar.',
                    please_contact_the_restaurant_directly: 'Bitte kontaktieren Sie das Restaurant direkt.',
                    almost_done: 'Fast fertig',
                    your_details: 'Ihre Angaben',
                    tell_us_who_s_coming: 'Sagen Sie uns, wer kommt, damit wir Ihre Reservierung bestätigen können.',
                    book_your_table: 'Reservieren Sie Ihren Tisch',
                    choose_a_time_that_works_for_you: 'Wählen Sie eine Zeit, die Ihnen passt.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Senden Sie Ihre Reservierungsanfrage und das Restaurant erledigt den Rest.',
                    select_date: 'Datum auswählen',
                    standard: 'Standard',
                    minutes: 'Minuten',
                    next: 'Weiter →',
                    back: '← Zurück',
                    accept_terms: 'Ich akzeptiere die Allgemeinen Geschäftsbedingungen.',
                    info_1: 'Sie erhalten eine E-Mail-Benachrichtigung, sobald Ihre Buchung akzeptiert oder abgelehnt wird',
                },
                errors: {
                    not_found: 'Buchung existiert nicht. Möglicherweise wurde es gelöscht',
                    booking_not_found: 'Buchung existiert nicht. Möglicherweise wurde sie gelöscht',
                    generic: 'Es ist ein Fehler aufgetreten. Aktualisieren Sie die Seite oder kontaktieren Sie uns',
                    something_went_wrong: 'Etwas ist schief gelaufen',
                    accept_terms: 'Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen (AGB)',
                    required_phone: 'Bitte geben Sie ihre Telefonnummer ein',
                    required_email: 'Bitte geben Sie ihre E-Mail-Adresse ein',
                    required_name: 'Bitte geben Sie Ihren Namen ein',
                    invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
                    invalid_phone: 'Bitte geben Sie eine gültige Telefonnummer ein',
                    invalid_people: 'Ungültige Anzahl von Personen',
                    booking_capacity_threshold: 'Für diese Zeit sind wir ausgebucht. Bitte versuchen Sie ein anderes Zeitfenster.',
                    slot_unavailable: 'Für diese Gruppengröße sind wir ausgebucht. Bitte versuchen Sie ein anderes Zeitfenster.',
                    booking_date_paused: 'Buchungen sind für dieses Datum pausiert. Bitte wählen Sie einen anderen Tag.',
                    invalid_table_assignment: 'Diese Tische bieten nicht genug Platz für Ihre Gruppe. Bitte wählen Sie eine andere Zeit.',
                    exceeded_order_limit: 'Zu viele Buchungsanfragen. Bitte versuchen Sie es später erneut.',
                    validation_failed_recaptcha_v3: 'Ungewöhnlicher Datenverkehr erkannt. Nutzen Sie ein VPN? Bitte lösen Sie die Aufgabe oben und versuchen Sie es erneut.',
                    validation_failed_recaptcha_v2: 'Die Buchung konnte nicht gestartet werden. Bitte versuchen Sie es erneut oder nutzen Sie eine andere Methode. Wenn Sie ein VPN verwenden, schalten Sie es zuerst aus.',
                    booking_already_exists: 'Diese Reservierung wurde bereits übermittelt. Prüfen Sie Ihre E-Mails oder öffnen Sie Ihren Buchungslink.',
                    invalid_party_size: 'Bitte wählen Sie eine gültige Gruppengröße.',
                    invalid_request: 'Ungültige Anfrage. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
                    table_booking_unavailable: 'Tischreservierung ist nicht verfügbar.',
                },
            },
            cart: {
                title: 'Warenkorb',
                proceed_to_checkout: 'Zur Kasse',
                edit_dish: 'Bearbeiten',
                remove_dish: 'Entfernen',
                no_items_1: 'Keine Artikel im Warenkorb',
                no_items_2: 'Fügen Sie zuerst etwas hinzu, um fortzufahren',
                free_delivery_notice: 'Kostenlose Lieferung für Bestellungen über {{value, currency}}',
                errors: {
                    min_order_promo: 'Mindestbestellwert von {{value, currency}} ist für die Anwendung dieses Gutscheincodes erforderlich',
                    min_order_delivery: 'Mindestbestellwert von {{value, currency}} ist für eine Lieferung erforderlich',
                },
                promo: {
                    heading: 'Gutscheincode',
                    placeholder: 'Gutscheincode eingegeben',
                    add: 'Gutscheincode hinzufügen',
                    title: 'Gutscheincode {{name}} zum Warenkorb hinzugefügt',
                    fixed_discount: '{{value, currency}} Aus',
                    percent_discount: '{{value}}% Aus',
                    added_to_cart: 'Gutscheincode zum Warenkorb hinzugefügt',
                    errors: {
                        not_found: 'Gutscheincode nicht gefunden',
                        disabled: 'Gutscheincode ist deaktiviert',
                        not_available: 'Gutscheincode ist derzeit nicht verfügbar',
                        logged_in_only: 'Mann muss eingeloggt sein, um diesen Gutscheincode zu nutzen',
                        already_used: 'Sie haben diesen Gutscheincode bereits verwendet',
                        invalid: 'Dieser Gutscheincode ist nicht mehr gültig',
                        invalid_service: 'Dieser Gutscheincode ist nicht anwendbar auf die von Ihnen gewählten Leistung',
                        later_only: 'Gilt nur für Vorbestellungen',
                        now_only: 'Gilt nur für Bestellungen mit sofortiger Fälligkeit, nicht für Vorbestellungen',
                        generic: 'Hoppla... etwas ist schief gelaufen und wurde gespeichert',
                        dishes_required_multi: 'Dieser Gutscheincode wird nur angewendet, wenn bestimmte Gerichte in Ihren Warenkorb gelegt werden',
                        dishes_required_single: "Dieser Gutscheincode wird nur für '{{dish}}' verwendet",
                    },
                },
                tip: {
                    title: 'Trinkgeld',
                    placeholder: 'Fügen Sie Trinkgeld hinzu',
                },
            },
            checkout: {
                title: 'Zur Kasse',
                subtitle: 'Bestätigen Sie Ihre Bestell Angaben',
                details: {
                    service: 'Bedienung',
                    due: 'Fällig',
                    due_now_asap: 'Jetzt / so schnell wie möglich',
                    address: 'Lieferadresse',
                    total: 'Summe',
                    table: 'Tisch',
                    store_location: 'Geschäftsadresse',
                },
                customer: {
                    title: 'Kunden',
                    subtitle: 'Loggen Sie sich ein, um Ihre Bestellung und Details zu speichern',
                    button: 'Einloggen',
                    name: 'Vollständiger Name',
                    email: 'E-Mail-Addresse',
                    phone: 'Telefonnummer',
                    phone_important: 'Telefonnummer (Wichtig)',
                    notes: 'Bestellhinweise',
                    delivery_notes: 'Lieferanweisungen / Bestellhinweise',
                    optional: 'Fakultativ',
                },
                payment: {
                    title: 'Zahlungsart',
                },
                accept_terms: 'Nutzungsbedingungen akzeptieren',
                accept_terms_view: 'Ansicht',
                processing_order: 'Auftrag wird bearbeitet',
                warning: {
                    different_payment_currency: 'Ladenpreise sind in {{store_currency}} aber die Zahlungsmethode ist in {{payment_currency}}',
                    closing_soon: 'Das Geschäft schließt bald. Bestellungen müssen innerhalb von {{value}} Minuten getätigt werden',
                    closed: 'Es tut uns leid, das Geschäft ist geschlossen und Bestellungen können nicht mehr angenommen werden',
                    expired: 'Wir können Ihre Bestellung zum ausgewählten Zeitpunkt nicht mehr erfüllen. Bitte wählen Sie ein späteres Datum oder eine spätere Uhrzeit',
                },
                errors: {
                    walletly_promo: 'Treuepunkte Rabatt Code konnte nicht eingelöst werden. Bitte entfernen Sie den Rabattcode, um die Bestellung abzuschließen',
                    stripe_generic: 'Mit der Kreditkarte ist ein Fehler aufgetreten, versuchen Sie es erneut oder eine andere Zahlungsart',
                    validation_failed: 'Diese Zahlung kann derzeit nicht akzeptiert werden. Bitte versuchen Sie es später erneut oder wählen Sie eine andere Zahlungsmethode.',
                    stripe_loading_fail: 'Fehler beim Laden des Zahlungsformulars, bitte versuche es erneut',
                    something_went_wrong: 'Etwas ist schief gelaufen',
                    paypal_generic: 'Bei PayPal ist ein Fehler aufgetreten, versuchen Sie es erneut oder wählen Sie eine andere Zahlungsart',
                    payment_fail: 'Bezahlung fehlgeschlagen, bitte versuchen Sie es erneut oder wählen Sie eine andere Zahlungsart',
                    payment_cancelled: 'Zahlung storniert, bitte versuchen Sie es erneut oder wählen Sie eine andere Zahlungsart',
                    payment_error: 'Fehler bei der Onlinezahlung, versuchen Sie es erneut oder wählen Sie eine andere Zahlungsart',
                    payment_declined: 'Ihre Zahlungsart wurde abgelehnt',
                    card_declined: 'Ihre Karte wurde abgelehnt und die Zahlung konnte nicht bearbeitet werden',
                    promo_max_uses_exceeded: "Dieser Gutscheincode hat sein Nutzungslimit erreicht und ist nicht mehr verfügbar.",
                    store_closed: 'Das Geschäft ist geschlossen und nimmt keine Bestellungen mehr an',
                    accept_terms: 'Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen (AGB)',
                    required_payment: 'Bitte wählen Sie eine Zahlungsart',
                    required_phone: 'Bitte geben sie ihre Telefonnummer ein',
                    required_email: 'Bitte geben Sie ihre E-Mail-Adresse ein',
                    required_name: 'Bitte geben Sie Ihren Namen ein',
                    invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
                    invalid_phone: 'Bitte geben Sie eine gültige Telefonnummer ein',
                    invalid_cc_number: 'Ihre Kreditkartennummer ist ungültig',
                    retry_cc_number: 'Etwas ist schief gelaufen, geben Sie Ihre Kreditkartennummer erneut ein und versuchen Sie es erneut',
                    closed: 'Der Laden ist geschlossen. Bestellungen können nicht mehr angenommen werden',
                    promo_login_required: 'Sie müssen eingeloggt sein, um diesen Gutscheincode zu nutzen',
                    promo_used: 'Sie haben diesen Gutscheincode bereits verwendet',
                    exceeded_order_limit: 'Wir erhalten gerade viele Bestellungen. Bitte wählen Sie eine spätere Uhrzeit.',
                    exceeded_order_limit_later: 'Wir können Ihre Bestellung zum ausgewählten Zeitpunkt nicht mehr ausführen. Bitte wählen Sie ein späteres Datum oder eine spätere Uhrzeit.',
                },
                button: {
                    continue: 'Weiter zur Bezahlung',
                    place_order: 'Bestellung aufgeben',
                },
            },
            customer: {
                age_v: {
                    title: 'Altersüberprüfung',
                    required_for_items: 'Erforderlich, um bestimmte Artikel zu bestellen',
                    min_age: 'Mindestalter: {{age}} Jahre alt',
                    est_time: 'Geschätzte Überprüfungszeit: {{time}} Stunde',
                    upload_description: 'Laden Sie unten Ihren Ausweis zur Bestätigung hoch. Sie werden nach der Bestätigung per E-Mail benachrichtigt. Laden Sie bis zu 2 Bilder mit einer maximalen Größe von jeweils 2 MB hoch',
                    pending_description_1: 'Vielen Dank für die Übermittlung Ihrer Unterlagen. Sie werden per E-Mail benachrichtigt, wenn Sie genehmigt wurden',
                    pending_description_2: 'Aktualisieren Sie die Seite, um Ihren Bestätigungsstatus zu aktualisieren. Geschätzte Überprüfungszeit ist {{time}} Std',
                    approved_description: 'Ihr Konto wurde verifiziert und Sie können anfangen zu bestellen',
                    rejected_description: 'Ihr Ausweis wurde abgelehnt. Wenn Sie es noch einmal versuchen möchten, laden Sie Ihren Ausweis erneut hoch',
                    upload: 'Hochladen',
                    reupload: 'Dokumente erneut hochladen',
                    go_back: 'Zurück',
                    view_document: 'Dokument anzeigen {{number}}',
                    status: {
                        unverified: 'Nicht verifiziert',
                        pending: 'Warten auf die Freigabe',
                        approved: 'Erfolgreich verifiziert',
                        rejected: 'Abgelehnt',
                    },
                },
                headings: {
                    sessions: 'Sitzungen',
                    orders: 'Bestellungen',
                    spend: 'Bezahlt',
                    order_history: 'Bestellhistorie',
                    loyalty_points: 'Treuepunkte',
                },
            },
            custom_payment: {
                title: '{{name}} Zahlungsformular',
                description: 'Sie haben unser Online-Zahlungsformular erreicht. Bitte füllen Sie die folgenden Felder aus, um eine Zahlung vorzunehmen. Wenn kein Betrag eingegeben wird, werden Ihre Daten gespeichert, aber nicht in Rechnung gestellt.',
                disabled: 'Diese Zahlungsart wurde nicht richtig konfiguriert. Wenden Sie sich an den Websitebetreiber, um das Problem zu beheben.',
                success: 'Ihre Zahlung wurde erfolgreich verarbeitet und Ihre Daten wurden gespeichert. Danke',
                back: 'Zurück zur Startseite',
                fields: {
                    name: 'Vollständiger Name',
                    email: 'E-Mail-Addresse',
                    reference: 'Zahlungsverwendungszweck',
                    amount: 'Betrag ($)',
                    name_on_card: 'Name auf der Karte',
                    submit: 'Zahlung durchführen',
                },
                warning: {
                    currency: 'Hinweis: Zahlungsbetrag in {{actual}}, nicht {{default}}',
                },
                errors: {
                    generic: 'Etwas ist schief gelaufen, versuchen Sie es erneut oder kontaktieren Sie uns',
                    stripe_generic: 'Kreditkartenfehler. Aktualisieren Sie die Seite und versuchen Sie es erneut',
                    payment_fail: 'Bezahlung fehlgeschlagen, Bitte versuchen Sie es erneut oder wählen Sie eine andere Zahlungsart',
                    payment_cancelled: 'Zahlung storniert, Bitte versuchen Sie es erneut oder wählen Sie eine andere Zahlungsart',
                    payment_error: 'Fehler bei der Online-Zahlung, Versuchen Sie es erneut oder wählen Sie eine andere Zahlungsart',
                    payment_declined: 'Ihre Zahlungsart wurde abgelehnt',
                    card_declined: 'Ihre Karte wurde abgelehnt und die Zahlung konnte nicht bearbeitet werden',
                    promo_max_uses_exceeded: "Dieser Gutscheincode hat sein Nutzungslimit erreicht und ist nicht mehr verfügbar.",
                },
            },
            dish: {
                add: 'In den Warenkorb',
                edit: 'Artikel aktualisieren',
                notes: ' Spezielle Anweisungen...',
                ingredients: {
                    title: 'Zutaten',
                    uncheck_remove: 'Zum Entfernen deaktivieren',
                },
                ingredients_title: 'Zutaten',
                combo: {
                    choose_dish: 'Wähle ein Gericht',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Wähle eins (Pflicht)',
                        select_one_optional: 'Wähle eins (Optional)',
                        select_between: 'Wählen Sie zwischen {{min}} - {{max}} (Pflicht)',
                        select_at_least: 'Wählen Sie mindestens {{qty}} (Pflicht)',
                        select_up_to: 'Wählen Sie bis zu {{qty}} (Optional)',
                        select_multiple: 'Wählen Sie mehrere aus (Optional)',
                        free_amount: 'Zuerst {{qty}} Kostenlos / {{selected}} Gewählt',
                    },
                },
                error: 'Bitte korrigieren Sie alle rot markierten Optionen',
                added_to_cart: 'Artikel zum Warenkorb hinzugefügt',
            },
            map: {
                zone_fee: 'Liefergebühr',
                view_in_google: 'In Google Maps anzeigen',
            },
            portal_go_back: {
                title: 'Zurück zur Restaurantsuche?',
                description: 'Alle Artikel in Ihrem Warenkorb werden entfernt',
                cancel: 'Abbrechen',
                proceed: 'Zurück',
            },
            order: {
                config: {
                    services: {
                        title: 'Wählen Sie einen Service',
                        table_booking: 'Tischreservierung',
                    },
                    address_custom: {
                        input_placeholder: 'Geben Sie Ihre Adresse ein',
                    },
                    address: {
                        input_placeholder: 'Finden Sie Ihre Lieferadresse',
                        extras_placeholder: 'Etage, Gebäude, usw...',
                        search_placeholder: 'Suchen Sie nach Ihrer Adresse',
                        not_found: 'Lieferadresse nicht gefunden oder ungültig. Versuch es noch einmal',
                        not_delivering: 'Wir liefern derzeit nicht an diese Adresse',
                        not_in_range: 'Ihre Adresse befindet sich nicht in unseren Lieferzonen',
                        not_in_zone: 'Ihre Adresse befindet sich nicht in einer aktiven Lieferzone',
                    },
                    datetime: {
                        title: 'Für wann möchten Sie bestellen',
                        due_now: 'Jetzt',
                        due_later: 'Später',
                        service_not_available: 'Es tut uns leid, wir akzeptieren derzeit keine Bestellungen für {{service}}',
                        currently_closed: '{{service}} Derzeit geschlossen, aber Sie können für später bestellen',
                        due_unavailable: 'Nicht verfügbar',
                        due_closed: 'Geschlossen',
                        select_date: 'Datum auswählen',
                        select_time: 'Zeit auswählen',
                        select_order_date: 'Wählen Sie Ihr Bestelldatum',
                        select_order_time: 'Wählen Sie Ihre Bestellzeit',
                        select_order_date_time: 'Wählen Sie das Datum/Uhrzeit für Ihre Bestellung',
                        select_booking_date: 'Wählen Sie Ihr Buchungsdatum',
                        select_booking_time: 'Wählen Sie Ihre Buchungszeit',
                        no_times_available: 'Es stehen keine Zeiten zur Auswahl',
                        date_today: '(Heute)',
                        date_closed: '(Geschlossen)',
                        date_bookings_paused: '(Buchungen pausiert)',
                        time_slot_closed: 'Geschlossen',
                    },
                    number_of_people: {
                        placeholder: 'Anzahl der Personen',
                    },
                    eta: {
                        delivery: `Ihre Bestellung wird voraussichtlich in {{minutesToCustomer}} Minuten fertig sein`,
                        pickup: `Die Bestellung ist in ca {{minutesToCustomer}} Minuten fertig`,
                    },
                    table: {
                        select: 'Tisch auswählen',
                        select_popup_title: 'Wählen Sie Ihren Tisch',
                        password: 'Tischpasswort',
                        password_warning: 'Geben Sie Ihr Tischpasswort ein, um fortzufahren',
                    },
                    warning: {
                        closed: 'Es tut uns leid. Wir sind derzeit geschlossen und nehmen keine Bestellungen mehr an',
                        not_available: 'Es tut uns leid. Wir akzeptieren derzeit keine Bestellungen',
                    },
                    start_button: 'Bestellung starten',
                },
                history: {
                    invalid: 'Nicht nachbestellbar, da einige der bestellten Artikel geändert wurden oder nicht mehr verfügbar sind',
                },
                reorder: {
                    title: 'Schnelle Nachbestellung',
                    description: 'Bestellen Sie die gleichen Artikel aus Ihren vorherigen Bestellungen',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Bestellung nicht gefunden, Aktualisieren Sie die Seite und versuchen Sie es erneut',
                    generic: 'Etwas ist schief gelaufen, Aktualisieren Sie die Seite oder kontaktieren Sie uns',
                },
                connection: {
                    connected: 'Echtzeit-Updates',
                    connecting: 'Echtzeit-Updates verbinden',
                    disconnected: 'Echtzeit-Updates getrennt',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Warnung',
                    title: 'Ausloggen',
                    body: 'Durch das Abmelden werden alle Artikel entfernt, die Ihrem Warenkorb hinzugefügt wurden',
                    cancel: 'Abbrechen',
                    proceed: 'Weiter',
                },
                order_restart: {
                    warning: 'Warnung',
                    title: 'Bestellung ändern',
                    body: 'Wenn Sie Ihre Bestellung ändern, werden die Artikel aus Ihrem Warenkorb entfernt, da bestimmte Gerichte möglicherweise nicht mehr verfügbar sind',
                    cancel: 'Abbrechen',
                    proceed: 'Fortfahren',
                },
                order_expired: {
                    subtitle: 'Wichtig',
                    title: 'Bestellung sofort fällig',
                    description: 'Die für Ihre Bestellung gewählte Zeit ist zu bald. Aus diesem Grund wurde Ihre Bestellung so geändert, dass diese sofort fällig ist',
                    button: 'Okay',
                },
                order_expiring: {
                    subtitle: 'Wichtig',
                    title: 'Bestellfrist läuft bald ab',
                    description: 'Ihre Bestellung muss sofort getätigt werden {{time, timeFromTimestamp}}, andernfalls ist diese nicht mehr gültig',
                    button: 'Okay',
                },
            },
        },
        sections: {
            nav_top: {
                guest: 'Gast',
                login: 'Einloggen',
                login_signup: 'Einloggen / Registrieren',
                logout: 'Ausloggen',
            },
            menus: {
                info: {
                    no_menus: 'Derzeit sind keine Menüs verfügbar',
                    restrictions: 'Menüeinschränkungen',
                    not_available: 'Menüs derzeit nicht verfügbar',
                    unavailable: {
                        times: 'Menü nicht verfügbar, Ihre Bestellanforderungen stimmen unten nicht überein',
                        services: 'Menü nicht verfügbar, Ihre Bestellanforderungen stimmen unten nicht überein',
                        hours: 'Menü nicht verfügbar, Ihre Bestellzeit liegt nicht innerhalb der Stunden in denen das Menü zur Verfügung steht',
                        pre_order: 'Menü nicht verfügbar, Ihre Bestellung entspricht nicht den Anforderungen für Vorbestellungen',
                        age: 'Menü nicht verfügbar, Sie müssen mit einem altersbestätigtem Konto angemeldet sein, um in diesem bestellen zu können',
                    },
                    services: {
                        title: 'Bestellarten',
                        pickup: 'Abholung',
                        delivery: 'Lieferung',
                        dine_in: 'Vor-Ort Verzehr',
                    },
                    times: {
                        now: 'Keine Vorbestellungen',
                        later: 'Nur Vorbestellungen',
                    },
                    hours: {
                        title: 'Verfügbare Stunden',
                    },
                    preorder: {
                        title: 'Voraussetzungen für die Vorbestellung',
                        days_in_advance: 'Man muss {{days}} Tage im voraus bestellen',
                        cutoff_time: 'Annahmeschluss am letzten Tag um {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Altersbeschränkt',
                        approved: 'Ihr Konto wurde verifiziert und Sie können über dieses Menü bestellen',
                        rejected: 'Zur Bestellung ist eine Altersüberprüfung erforderlich. Erstellen Sie ein Konto und laden Sie Ihre Ausweis hoch',
                    },
                },
            },
            info: {
                location: {
                    title: 'Standort',
                    view_map: 'Karte ansehen',
                    phone: 'Telefon',
                },
                hours: {
                    title: 'Öffnungszeiten',
                    title_special: 'Besondere Öffnungszeiten',
                },
                services: {
                    title: 'Leistungen',
                    notes: 'Anmerkungen',
                    delivery: {
                        ranges: 'Lieferbereiche',
                        zones: 'Lieferzonen',
                        view_zones: 'Lieferzonen auf Karte anzeigen',
                        fee: 'Liefergebühr',
                        fee_short: 'Gebühr',
                        fee_varies: 'Variiert, im Warenkorb angezeigt',
                        min_order: 'Mindestbestellwert',
                        min_order_short: 'Min. Best.',
                        no_min_order: 'Kein Mindestbestellwert',
                        free_amount: 'Kostenlose Lieferung',
                    },
                },
            },
            contact: {
                title: 'Kontaktiere uns',
                name: 'Vollständiger Name',
                email: 'E-Mail-Adresse',
                phone: 'Telefonnummer',
                message: 'Gib deine Nachricht ein...',
                send: 'Nachricht senden',
                success: 'Ihre Nachricht wurde erfolgreich gesendet',
                error: 'Etwas ist schief gelaufen. Versuchen Sie es erneut oder zu einem späteren Zeitpunkt',
            },
            footer: {
                powered_by: 'Betrieben durch',
                terms_and_conditions: 'Geschäftsbedingungen',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Buchungsbeleg',
            details: {
                datetime: 'Reservierung für',
                number_of_people: 'Anzahl der Personen',
                placed: 'Platziert',
                updated: 'Zuletzt aktualisiert',
                notes: 'Anmerkungen',
                name: 'Name',
                email: 'Email',
                phone: 'Telefon',
                store_address: 'Geschäftsadresse',
            },
            status_update: {
                title: 'Buchung {{number}} aktualisiert',
                body: 'Ihr Buchungsstatus wurde auf {{status}} aktualisiert',
            },
            email_status_update_customer: {
                subject: 'Buchung #{{number}} – {{subjectLabel}}',
                body: 'Ihre Buchung #{{number}} bei {{store}} ist jetzt {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Bestellung #{{number}} – {{subjectLabel}}',
        header: 'Aktualisierte Fertigstellungszeit',
        title: 'Aktualisierte Fertigstellungszeit',
        order_number: 'Bestellingsnummer: {{number}}',
        description: 'Ihre Bestellung ist jetzt um {{time}} fertig.',
        order_time_updated_to: 'Die Zeit Ihrer Bestellung wurde aktualisiert.',
        powered_by: 'Bereitgestellt von {{name}}',
        button_text: 'Bestellung verfolgen',
        subject_label: 'Aktualisierte Fertigstellungszeit',
        subject_label_delivery: 'Aktualisierte Lieferzeit',
        body_ready: 'Ihre Bestellung ist jetzt um {{time}} fertig.',
        body_delivery: 'Ihre Bestellung wird jetzt um {{time}} geliefert.',
    },
    order: {
        receipt: {
            est_ready_time: 'geschätzte Zubereitungszeit',
            est_driver_pickup_time: 'geschätzte Abholzeit des Fahrers',
            est_delivery_time: 'Voraussichtliche Lieferzeit',
            tab_details: 'Details',
            tab_dishes: 'Speisen',
            details: {
                status: 'Status',
                placed: 'Aufgenommen',
                due: 'Fällig',
                due_asap: 'Jetzt / so schnell wie möglich',
                last_updated: 'Zuletzt aktualisiert',
                total: 'Summe',
                type: 'Art',
                table: 'Tisch',
                number_of_people: 'Anzahl der Personen',
                payment_method: 'Zahlungsart',
                payment_status: 'Zahlungsstatus',
                payment_currency: 'Währung',
                notes: 'Anmerkungen',
                name: 'Name',
                email: 'E-Mail',
                phone: 'Telefon',
                distance: 'Entfernung',
                driving_time: 'Fahrzeit',
                delivery_zone: 'Lieferzone',
                delivery_address: 'Lieferadresse',
                delivery_tracking: 'Lieferverfolgung',
                delivery_tracking_link: 'Echtzeit-Tracking-Link',
                tookan_status: 'Tookan-Status',
                tookan_status_failed_book: 'Lieferung konnte nicht gebucht werden',
                tookan_status_failed_update: 'Buchung konnte nicht aktualisiert werden',
                tookan_status_success: 'Lieferung erfolgreich gebucht',
                store_address: 'Geschäftsadresse',
            },
            dishes: {
                headings: {
                    quantity: 'Menge',
                    item: 'Artikel',
                    price: 'Preis',
                },
                notes: 'Anmerkungen',
                remove_ingredients: 'Zutaten entfernen',
            },
            status_update: {
                title: 'Bestellung {{number}} aktualisiert',
                body: 'Ihr Bestellstatus wurde auf {{status}} aktualisiert',
            },
            wait_time_update: {
                title: 'Bestellung {{number}} aktualisiert',
                body: 'Ihre Bestellung wurde aktualisiert',
            },
            delivery_update: {
                title: 'Bestellung {{number}} aktualisiert',
                body: 'Ihre Bestellung wurde für die Lieferung gebucht. Siehe Echtzeit-Tracking-Link',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: 'New Order ({{number}}) - {{name}}',
                powered_by: 'Powered By {{name}}',
                overview: 'New Order Notification',
                title: 'New Order Placed At {{name}}',
                subtitle: 'Order Number {{number}}',
                description: 'View details and updates through your admin dashboard',
                button_text: 'Bestellung verfolgen',
                track_delivery_button_text: 'Lieferung verfolgen',
            },
            email_new_order_customer: {
                subject: 'Order Receipt ({{number}})',
                powered_by: 'Powered By {{name}}',
                overview: 'New Order Notification',
                title: 'New Order Placed At {{name}}',
                subtitle: 'Order Number {{number}}',
                description: 'View details and updates through your real-time online receipt',
                button_text: 'Bestellung verfolgen',
                track_delivery_button_text: 'Lieferung verfolgen',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) inkl.',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Liefergebühr',
            promo: 'Rabatt: {{name}} ({{value, currency}} + {{percent}}% Off)',
            promo_percent: 'Rabatt: {{name}} ({{percent}}%)',
            promo_fixed: 'Rabatt: {{name}}',
            promo_none: 'Rabatt: {{name}}',
            cart: 'Warenkorb',
            tip: 'Trinkgeld',
            total: 'Summe',
        },
        status: {
            unconfirmed: 'Unbestätigt',
            awaiting_payment: 'Warten auf Zahlung',
            confirmed: 'Bestätigt',
            ready: 'Bereit',
            on_route: 'Unterwegs',
            complete: 'Abgeschlossen',
            cancelled: 'Stoniert',
            seated: 'Platziert',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Nicht verfügbar',
                },
            },
            dish: {
                no_stock: 'Nicht vorhanden',
                not_available: 'Nicht verfügbar',
            },
        },
    },
};
//# sourceMappingURL=de.js.map